import * as yup from "yup";

const IVANS_ACCOUNT_ID_REGEX = /^[Yy][a-zA-Z0-9]{3,4}$/gm;
const IVANS_USER_ID_REGEX = /^[a-zA-Z0-9]{4,12}$/gm;

const MAX_LENGTH_MESSAGE = "Length cannot be greater than 50 characters.";
const MIN_LENGTH_MESSAGE = "Length should be at least 2 characters.";

export const validationSchema = yup.object().shape({
    languageSelections: yup.array().optional(),
    otherLanguageSelections: yup.string().default("")
        .when("languageSelections", {
            is: (value) => value?.includes("OTHER"),
            then: (schema) => schema.required("Please specify the language")
                .min(2, MIN_LENGTH_MESSAGE)
                .max(50, MAX_LENGTH_MESSAGE)
        }),
    managementSystem: yup.string().required("Please select an option"),
    otherManagementSystem: yup.string().default("")
        .when("managementSystem", {
            is: (value) => value?.includes("OTHER"),
            then: (schema) => schema.required("Please specify the management system")
                .min(2, MIN_LENGTH_MESSAGE)
                .max(50, MAX_LENGTH_MESSAGE)
        }),
    comparativeRater: yup.string().required("Please select an option"),
    otherComparativeRater: yup.string().default("")
        .when("comparativeRater", {
            is: (value) => value?.includes("OTHER"),
            then: (schema) => schema.required("Please specify the comparative rater")
                .min(2, MIN_LENGTH_MESSAGE)
                .max(50, MAX_LENGTH_MESSAGE)
        }),
    acceptsAndUsesIvansDownload: yup.bool().required("Please select Yes or No"),
    ivansAccountId: yup.string().default("")
        .when("acceptsAndUsesIvansDownload", {
            is: (value) => value === true,
            then: () => yup.string().required("Please enter Ivans Account ID")
                .min(4, "IVANS Account ID length should be at least 4 characters.")
                .max(5, "IVANS Account ID length cannot be greater than 5 characters.")
                .matches(IVANS_ACCOUNT_ID_REGEX, "Valid format is Y followed by 3 or 4 alphanumeric characters.")
        }),
    ivansUserId: yup.string().default("")
        .when("acceptsAndUsesIvansDownload", {
            is: (value) => value === true,
            then: () => yup.string().required("Please enter Ivans User ID")
                .min(4, "IVANS User ID length should be at least 4 characters.")
                .max(12, "IVANS User ID length cannot be greater than 12 characters.")
                .matches(IVANS_USER_ID_REGEX, "IVANS User ID should be alphanumeric and contain 4 to 12 characters.")
        }),
    associations: yup.array().default([]).min(1, "Please select at least one option")
});